<script>
import {
  ArrowUpIcon,
  MonitorIcon,
  HeartIcon,
  EyeIcon,
  BoldIcon,
  FeatherIcon,
  CodeIcon,
  UserCheckIcon,
  GitMergeIcon,
  SettingsIcon,
  VideoIcon,
  FacebookIcon,
  InstagramIcon,
  TwitterIcon,
  LinkedinIcon,
  MailIcon,
} from "vue-feather-icons";
import countTo from "vue-count-to";

import { Carousel, Slide } from "vue-carousel";

import LoginModal from "@/components/login-modal";
import Navbar from "@/components/navbar";
import Testimonial from "@/components/testimonial";
import Pricing from "@/components/pricing2";
import Footer from "@/components/footer";
import {post} from "@/assets/js/utils";
import config from "@/config.json";

/**
 * Index-marketing component
 */
export default {
  data() {
    return {
      selected: 0,
      lang: this.getLang()
    };
  },
  methods: {
  },
  components: {
    Navbar,
    Testimonial,
    Carousel,
    Slide,
    Pricing,
    Footer,
    ArrowUpIcon,
    MonitorIcon,
    HeartIcon,
    EyeIcon,
    BoldIcon,
    FeatherIcon,
    CodeIcon,
    UserCheckIcon,
    VideoIcon,
    GitMergeIcon,
    SettingsIcon,
    FacebookIcon,
    InstagramIcon,
    TwitterIcon,
    LinkedinIcon,
    MailIcon,
    countTo,
    LoginModal,
  },
};
</script>

<template>
  <div>
    <Navbar />

    <!-- Hero Start -->
    <section
      class="bg-marketing d-table w-100"
      style="background: url('images/marketing/marketing-shape.png')"
      id="home"
    >

      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-8 text-center">
            <div class="title-heading mt-0 mt-md-5 pt-2 pt-sm-0">
              <h1 class="heading mb-3">{{ $t('team.title') }}</h1>
              <p class="para-desc mx-auto">{{ $t('team.description') }}</p>
            </div>
          </div>
        </div>
      </div>

      <div class="container mt-5">
        <Pricing :pricing-data="$t('index.price.plans')" :type="2"/>
      </div>

    </section>
    <!--end section-->
    <!-- Hero End -->


    <Footer />

    <!-- Footer End -->
    <!-- Back to top -->
    <a
      href="javascript: void(0);"
      class="btn btn-icon btn-primary back-to-top"
      id="back-to-top"
      v-scroll-to="'#topnav'"
    >
      <arrow-up-icon class="icons"></arrow-up-icon>
    </a>
    <!-- Back to top -->
  </div>
</template>
